import jwtInterceptor from '/src/shared/jwtInterceptor'

const apiUrl = process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH;

const actions = {
  async getMission(c,id)
  {
    const url = apiUrl + 'mission/get/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  },
  async getCustomerInfo(c,id)
  {
    const url = apiUrl + 'Mission/GetUserInfo/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  },
  async getNoOrderReason()
  {
    const url = apiUrl + 'NoOrderReason/get';
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  },
  async getDocTypes()
  {
    const url = apiUrl + 'docType/get';
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  },
  async getIncomingDoc(c,id)
  {
    const url = apiUrl + 'incomingDoc/get/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }



};

export default {
  namespaced: true,
  actions
}